<template>
  <audio autoplay :muted="local" ref="player" />
</template>

<script>
export default {
  props: {
    track: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      local: this.track.isLocal()
    };
  },
  mounted() {
    this.track.attach(this.$refs.player);
  },
  beforeDestroy() {
    this.track.dispose();
  }
};
</script>
